import * as React from "react";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import { useWindowSize } from "./useWindowSize";

export function useBreakpoint() {
  const [breakpoint, setBreakpoint] = React.useState<{
    isLarge: boolean;
    isMedium: boolean;
    isSmall: boolean;
  }>({
    isLarge: false,
    isMedium: false,
    isSmall: false,
  });

  const { width } = useWindowSize();
  const [, theme] = useStyletron();

  React.useEffect(() => {
    const _breakpoint = {
      isLarge: false,
      isMedium: false,
      isSmall: false,
    };
    if (width < theme.breakpoints.medium) {
      setBreakpoint({ ..._breakpoint, isSmall: true });
    } else if (width < theme.breakpoints.large) {
      setBreakpoint({ ..._breakpoint, isMedium: true });
    } else {
      setBreakpoint({ ..._breakpoint, isLarge: true });
    }
  }, [width]);

  return breakpoint;
}
